/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const Translations = {

    staticPages: {
        label: {
            fileAttachments: "staticPages:label.fileAttachments",
        },
    },

    routes: {
        title: {
            classifications: "routes:title.classifications",
            easyToRead: "routes:title.easyToRead",
            home: "routes:title.home",
            lodResources: "routes:title.lodResources",
            searchResults: "routes:title.searchResults",
        },
    },

    pages: {
        title: {
            classifications: "pages:title.classifications",
            easyToRead: "pages:title.easyToRead",
            lodResources: "pages:title.lodResources",
            pageNotFound: "pages:title.pageNotFound",
            searchResults: "pages:title.searchResults",
        },
    },

    pageNotFound: {
        button: {
            back: "pageNotFound:button.back",
        },
        text: {
            caption1: "pageNotFound:text.caption1",
            caption2: "pageNotFound:text.caption2",
            heading: "pageNotFound:text.heading",
        },
    },

    navBar: {
        button: {
            allClassifiers: "navBar:button.allClassifiers",
            language: "navBar:button.language",
            search: "navBar:button.search",
            settings: "navBar:button.settings",
        },
        label: {
            accessibility: "navBar:label.accessibility",
            contrast: "navBar:label.contrast",
            cookieSettings: "navBar:label.cookieSettings",
            fontSize: "navBar:label.fontSize",
            language: "navBar:label.language",
            searchClassifier: "navBar:label.searchClassifier",
        },
    },

    lod: {
        label: {
            attachedRdfFiles: "lod:label.attachedRdfFiles",
            classifierTitle: "lod:label.classifierTitle",
            code: "lod:label.code",
            predicate: "lod:label.predicate",
            rdfFileType: "lod:label.rdfFileType",
            resourceName: "lod:label.resourceName",
            topLevelResource: "lod:label.topLevelResource",
            value: "lod:label.value",
        },
    },

    globalSearch: {
        infoBox: {
            contactEmail: "globalSearch:infoBox.contactEmail",
            contactJobTitle: "globalSearch:infoBox.contactJobTitle",
            contactName: "globalSearch:infoBox.contactName",
            contactPhoneNumber: "globalSearch:infoBox.contactPhoneNumber",
            subtitle: "globalSearch:infoBox.subtitle",
            title: "globalSearch:infoBox.title",
        },
    },

    formats: {
        date: {
            text: "formats:date.text",
        },
    },

    footer: {
        link: {
            aboutPage: "footer:link.aboutPage",
            accessibility: "footer:link.accessibility",
            api: "footer:link.api",
            contacts: "footer:link.contacts",
            lodResources: "footer:link.lodResources",
            privacyPolicy: "footer:link.privacyPolicy",
            siteMap: "footer:link.siteMap",
        },
        subtitle: {
            about: "footer:subtitle.about",
        },
        title: {
            about: "footer:title.about",
        },
    },

    enumerators: {
        common: {
            none: "enumerators:common.none",
        },
        fileType: {
            csv: "enumerators:fileType.csv",
            json: "enumerators:fileType.json",
            xlsx: "enumerators:fileType.xlsx",
            xml: "enumerators:fileType.xml",
        },
    },

    copyright: {
        label: {
            text: "copyright:label.text",
        },
    },

    cookies: {
        button: {
            aboutUsedCookies: "cookies:button.aboutUsedCookies",
            fullConsent: "cookies:button.fullConsent",
            limitedConsent: "cookies:button.limitedConsent",
        },
        column: {
            cookie: "cookies:column.cookie",
            description: "cookies:column.description",
            expirationDate: "cookies:column.expirationDate",
            group: "cookies:column.group",
        },
        links: {
            accessibility: "cookies:links.accessibility",
            privacyPolicy: "cookies:links.privacyPolicy",
        },
        modal: {
            title: "cookies:modal.title",
        },
        text: {
            caption1: "cookies:text.caption1",
            caption2: "cookies:text.caption2",
        },
    },

    common: {
        button: {
            open: "common:button.open",
        },
        label: {
            errorCopySuccess: "common:label.errorCopySuccess",
            linkCopySuccess: "common:label.linkCopySuccess",
            loadingData: "common:label.loadingData",
            noClassifications: "common:label.noClassifications",
            noClassificationsDescription: "common:label.noClassificationsDescription",
            search: "common:label.search",
            validFrom: "common:label.validFrom",
            validTo: "common:label.validTo",
        },
        tooltip: {
            copyPageLink: "common:tooltip.copyPageLink",
            copyRecordLink: "common:tooltip.copyRecordLink",
            downloadFile: "common:tooltip.downloadFile",
            openRecord: "common:tooltip.openRecord",
            printPage: "common:tooltip.printPage",
            recordDesc: "common:tooltip.recordDesc",
        },
    },

    classifier: {
        button: {
            rateSearch: "classifier:button.rateSearch",
        },
        label: {
            fileDate: "classifier:label.fileDate",
            learnMore: "classifier:label.learnMore",
            noClassificationRecords: "classifier:label.noClassificationRecords",
            noClassificationRecordsDescription: "classifier:label.noClassificationRecordsDescription",
            relatedFiles: "classifier:label.relatedFiles",
        },
        mainData: {
            dateInputToday: "classifier:mainData.dateInputToday",
            download: "classifier:mainData.download",
            insufficientSearchPhrase: "classifier:mainData.insufficientSearchPhrase",
            language: "classifier:mainData.language",
            level: "classifier:mainData.level",
            search: "classifier:mainData.search",
            valuesOnDate: "classifier:mainData.valuesOnDate",
            view: "classifier:mainData.view",
            viewHierarchical: "classifier:mainData.viewHierarchical",
            viewLinear: "classifier:mainData.viewLinear",
            viewSettingsTitle: "classifier:mainData.viewSettingsTitle",
        },
        passportItem: {
            abbreviation: "classifier:passportItem.abbreviation",
            area: "classifier:passportItem.area",
            author: "classifier:passportItem.author",
            availability: "classifier:passportItem.availability",
            classificationObject: "classifier:passportItem.classificationObject",
            codingSystem: "classifier:passportItem.codingSystem",
            contactPerson: "classifier:passportItem.contactPerson",
            coResponsibleAuthority: "classifier:passportItem.coResponsibleAuthority",
            legalBasis: "classifier:passportItem.legalBasis",
            mainAuthority: "classifier:passportItem.mainAuthority",
            plannedRevision: "classifier:passportItem.plannedRevision",
            publicated: "classifier:passportItem.publicated",
            publicationYear: "classifier:passportItem.publicationYear",
            purpose: "classifier:passportItem.purpose",
            status: "classifier:passportItem.status",
        },
        relatedBlock: {
            title: "classifier:relatedBlock.title",
        },
        tabItems: {
            classifierAndDownloads: "classifier:tabItems.classifierAndDownloads",
            passportData: "classifier:tabItems.passportData",
        },
        text: {
            downloadSuccess: "classifier:text.downloadSuccess",
            rateSearchContent: "classifier:text.rateSearchContent",
            rateSearchTitle: "classifier:text.rateSearchTitle",
            rateSuccess: "classifier:text.rateSuccess",
            relatedNotPublished: "classifier:text.relatedNotPublished",
            settingPlMsgDateFilter: "classifier:text.settingPlMsgDateFilter",
        },
        tooltip: {
            searchThumbDown: "classifier:tooltip.searchThumbDown",
            searchThumbUp: "classifier:tooltip.searchThumbUp",
        },
    },

    classifierList: {
        facet: {
            all: "classifierList:facet.all",
            area: "classifierList:facet.area",
            author: "classifierList:facet.author",
            authority: "classifierList:facet.authority",
            availability: "classifierList:facet.availability",
            extraField1: "classifierList:facet.extraField1",
            extraField2: "classifierList:facet.extraField2",
            extraField3: "classifierList:facet.extraField3",
            extraField4: "classifierList:facet.extraField4",
            publicationYear: "classifierList:facet.publicationYear",
            region: "classifierList:facet.region",
        },
        sortOrder: {
            ascending: "classifierList:sortOrder.ascending",
            descending: "classifierList:sortOrder.descending",
            mostPopular: "classifierList:sortOrder.mostPopular",
        },
    },
}
